import axios from "axios";
import store from '../index';

export default {
    namespaced: true,
    state: {
        projectId: '',
        withClosedProject: false,
        filter: {
            l1:'',
            l2:'',
            l3:'',
            l4:'',
            l5:'',
            status: '',
            assignee: '',
            startDate: '',
            dueDate: '',
            keyword: ''
        },
        expanded: {},
        filterExpanded: true,
        wbsScheduleChartExpandState: false,
        expandableItemCount: 0,
        expandedItemCount: 0,
        colorInfoByStatusAndDepth: {
            OPEN: ["#ECECEC", "#D9D9D9", "#C6C6C6", "#B3B3B3", "#A0A0A0", "#8D8D8D", "#7A7A7A", "#676767", "#545454", "#414141"],
            TO_DO : ['#C0C0C0', '#ADADAD', '#989898', '#666666', '#484848', '#262626'],
            IN_PROGRESS : ["#fcefcf", "#fae4ae", "#f8d98c", "#ffe194", "#ffd466"],
            DONE : ["#CFDDFF", "#adc5ff", "#8fb0ff", "#709bff", "#5286ff"],
            CANCELLED : ['#e4e4ea', '#e4e4ea', '#e4e4ea', '#e4e4ea', '#e4e4ea'],
            CLOSED: ["#D7F5D6", "#bbeeb9", "#9fe79c", "#83e080", "#6bda67"],
        }
    },
    getters: {
        projectId(state) {
            return state.projectId;
        },
        withClosedProject(state) {
            return state.withClosedProject;
        },
        getExpanded: (state) => (id) => {
            return state.expanded[id];
        },
        getFilter(state) {
            return state.filter;
        },
        getFilterExpanded(state) {
            return state.filterExpanded;
        },
        getWbsScheduleChartExpandState(state) {
            return state.wbsScheduleChartExpandState;
        },
        getColorInfoByStatusAndDepth(state) {
            return state.colorInfoByStatusAndDepth;
        },
        getExpandableItemCount(state) {
            return state.expandableItemCount;
        },
        getExpandedItemCount(state) {
            return state.expandedItemCount;
        }
    },
    mutations: {
        setProjectId(state, projectId) {
            state.projectId = projectId
        },
        setWithClosedProject(state, value) {
            state.withClosedProject = value;
        },
        /**
         * devMethodology의 Id, 혹은 chatId가 올 수 있음
         * @param {*} state 
         * @param {*} id 
         */
        setExpanded(state, payload) {
            const id = payload.id;
            const isExpanded = payload.isExpanded;
            const expanded = {
                ...state.expanded,
                [id]: isExpanded
            }
            state.expanded = expanded;
            if (isExpanded) {
                if(state.expandableItemCount > state.expandedItemCount) {
                    state.expandedItemCount += 1
                }

            } else {
                if(state.expandedItemCount > 0) {
                    state.expandedItemCount -= 1
                }
            }
        },
        resetExpanded(state) {
            state.expandedItemCount = 0;
            state.expanded = {};
        },
        resetFilter(state) {
            state.filter = {
                l1:'',
                l2:'',
                l3:'',
                l4:'',
                l5:'',
                status: '',
                assignee: '',
                startDate: '',
                dueDate: '',
                keyword: ''
            };
        },
        setFilterExpanded(state, value) {
            state.filterExpanded = value;
        },
        setWbsScheduleChartExpandState(state, value) {
            state.wbsScheduleChartExpandState = value;
        },
        setExpandableItemCount(state, value) {
            state.expandableItemCount = value;
        }
    }

}